import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export default function CardMiEmpresa({ empresa, scrollToTop }) {
  return (
    <Link
      to={`/empresa/${empresa.uid}`}
      onClick={() => {
        scrollToTop();
      }}
      key={empresa.uid}
      className="group/business relative bg-cover bg-center h-48 rounded-lg bg-aw-bluegray duration-300 hover:scale-95 active:scale-95 transition-scale ring-aw-green/50 hover:ring-aw-green/90 active:ring-aw-green/90 ring-2"
      style={{ backgroundImage: `url(${empresa.imgPortadaEmpresa})` }}
    >
      <div className="w-full h-full bg-aw-bluedark/60 rounded-lg p-4 group-hover/business:pt-16 group-hover/business:bg-aw-bluedark/80 group-active/business:pt-10 group-active/business:bg-aw-bluedark/80 duration-400">
        <h4 className="text-white font-semibold max-w-2/3 text-xl">{empresa.nombre}</h4>
        {/* <p className="text-aw-green font-semibold">
          <FontAwesomeIcon icon="fa-solid fa-user-group" className="mr-1" />
          {empresa.numeroSeguidores} seguidores
        </p> */}
        <p className="text-aw-green text-sm font-semibold">
          <FontAwesomeIcon icon="fa-solid fa-calendar-check" className="mr-1" />
          {empresa.numeroEventosActivos} {empresa.numeroEventosActivos <= 1 ? "Evento Activo" : "Eventos Activos"}
        </p>
        <div className="absolute bottom-4 right-4">
          <img
            src={empresa.imgPerfilEmpresa}
            alt={empresa.nombre}
            className="w-16 h-16 rounded-full border-2 border-white object-cover group-hover/business:w-32 group-hover/business:h-32 group-active/business:w-32 group-active/business:h-32 duration-300"
          />
        </div>
      </div>
    </Link>
  );
}
